import React from "react";
import { Button, Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const HeaderIsEmpty = ({ toggleSection }) => {
  return <Typography sx={{color: "black", mt: 1, display: "inline"}} variant="body2"><TranslationContent contentID="headerIsEmptyDesc" /><Button size="small" sx={{color: "#668CBB"}} onClick={() => toggleSection("headerTypeInvalid")}><TranslationContent contentID="headerTypeInvalid" /></Button></Typography>
}

export default HeaderIsEmpty;